// `datetime` is venue-local time with no zone (e.g. 2026-10-09T20:00:00), so work with the
// calendar parts directly instead of letting a Date shift it.
export function dayKey(datetime: string): string {
  return datetime.slice(0, 10);
}

// e.g. "Friday Oct 9 - 9:00pm" (or "Friday Oct 9" when there is no time)
export function formatShowDate(datetime: string): string {
  const [y, m, d] = dayKey(datetime).split('-').map(Number);
  const date = new Date(y, m - 1, d);
  const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
  const monthDay = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const day = `${weekday} ${monthDay}`;
  const [hh, mm] = datetime.slice(11, 16).split(':').map(Number);
  if (Number.isNaN(hh) || Number.isNaN(mm)) return day;
  const time = `${hh % 12 || 12}:${String(mm).padStart(2, '0')}${hh < 12 ? 'am' : 'pm'}`;
  return `${day} - ${time}`;
}
